export function onlyNumbers(value: string): string {
  return value.replace(/\D/g, '')
}

export function normalizeCNPJ(value?: string | null): string {
  if (!value) return ''
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '')
}

const CPF_PATTERN = /^\d{11}$/
const CNPJ_TOTAL_LENGTH = 14
const CNPJ_BASE_LENGTH = 12
const CNPJ_DV1_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const CNPJ_DV2_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

const calcDigit = (value: number) => {
  const digit = value % 11
  if (digit === 10) {
    return 0
  }
  return digit
}

export function validateCPF(cpf: string) {
  if (
    !CPF_PATTERN.test(cpf) ||
    [...cpf].filter((e) => e !== cpf[0]).length === 0
  ) {
    return false
  }

  const mutable_cpfArray = [...cpf]
    .slice(0, 9)
    .map((v) => Number.parseInt(v, 10))
  const firstDigit = calcDigit(
    mutable_cpfArray.reduce((a, v, i) => v * (i + 1) + a),
  )
  mutable_cpfArray.push(firstDigit)
  const secondDigit = calcDigit(
    mutable_cpfArray.reduce((a, v, i) => i * v + a, 0),
  )
  mutable_cpfArray.push(secondDigit)
  return mutable_cpfArray.join('') === cpf
}

export function validateCNPJ(cnpj: string): boolean {
  const normalizedCNPJ = normalizeCNPJ(cnpj)
  if (!/^[A-Z0-9]{14}$/.test(normalizedCNPJ)) {
    return false
  }

  const base12 = normalizedCNPJ.slice(0, CNPJ_BASE_LENGTH)
  const providedDv = normalizedCNPJ.slice(CNPJ_BASE_LENGTH)

  const mapCnpjCharToValue = (char: string): number => {
    if (char >= '0' && char <= '9') {
      return Number(char)
    }

    return char.charCodeAt(0) - 48
  }

  const calculateCnpjCheckDigit = (
    input: string,
    weights: number[],
  ): number => {
    const sum = input.split('').reduce((acc, char, index) => {
      return acc + mapCnpjCharToValue(char) * weights[index]
    }, 0)

    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  const providedDv1 = Number(providedDv.charAt(0))
  const providedDv2 = Number(providedDv.charAt(1))
  const expectedDv1 = calculateCnpjCheckDigit(base12, CNPJ_DV1_WEIGHTS)
  const expectedDv2 = calculateCnpjCheckDigit(
    `${base12}${providedDv1}`,
    CNPJ_DV2_WEIGHTS,
  )

  return providedDv1 === expectedDv1 && providedDv2 === expectedDv2
}
